<template>
    <div>
        <div v-if="!inYoda">
            <div class="page-title">
                <slot name="left-button"></slot>{{title}}
            </div>
            <div class="page-title-placeholder"></div>
        </div>
        <div v-else-if="useTitleValue">
            <div class="page-title-in-yoda">
                {{ title }}
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.page-title {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    font-size: 17px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #222222;
    background: #fff;
    border-bottom: 1px solid #eaeaea;
    z-index: 999;
}
.page-title-placeholder {
    height: 44px;
    position: fixed;
    left: 0;
    top: 0;
}
.page-title-in-yoda {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    padding-top: 44px;
    height: 44px;
    line-height: 44px;
    font-size: 17px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #222222;
    background: #fff;
    border-bottom: 1px solid #eaeaea;
    z-index: 999;
}
</style>

<script>
import { inYoda } from '@/utils/device';
import { mapState } from 'vuex';

export default {
    name: 'nav-bar',
    props: {
        title: {
            type: String,
            default: '信息收集',
        },
    },
    computed: {
        ...mapState(['useTitle']),
        inYoda() {
            return inYoda;
        },
        useTitleValue() {
            return this.useTitle;
        },
    },
};
</script>
